import { useState } from "react";
import { Alert, Button, Card, Container, Form } from "react-bootstrap";
import { useAuth } from "../auth/AuthContext";
import { portalIcon } from "../lib/appIcons";

export default function LoginPage() {
  const { config, startSsoLogin, loginLocal } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const ssoEnabled = config?.sso.enabled ?? false;
  const localEnabled = config?.localLoginEnabled ?? false;

  const submitLocal = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const ok = await loginLocal(email, password);
    setBusy(false);
    if (!ok) setError("Sign-in failed. Check your email and password.");
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card style={{ maxWidth: 420, width: "100%" }}>
        <Card.Body className="p-4">
          <div className="text-center mb-3">
            <img src={portalIcon} alt="" style={{ width: 80, height: 80 }} className="rounded-3" />
          </div>
          <h4 className="mb-1 text-center">TTS Engineering Portal</h4>
          <p className="text-muted mb-4 text-center">One place to open every TTS engineering app</p>

          {ssoEnabled && (
            <div className="d-grid mb-3">
              <Button
                className="d-flex align-items-center justify-content-center gap-2"
                onClick={() => void startSsoLogin()}
              >
                <MicrosoftLogo /> Sign in with Microsoft
              </Button>
            </div>
          )}

          {ssoEnabled && localEnabled && (
            <div className="d-flex align-items-center my-3 text-secondary" style={{ fontSize: ".75rem" }}>
              <hr className="flex-grow-1 m-0" />
              <span className="px-2">or</span>
              <hr className="flex-grow-1 m-0" />
            </div>
          )}

          {localEnabled && (
            <Form onSubmit={(e) => void submitLocal(e)}>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form.Group className="mb-2">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </Form.Group>
              <div className="d-grid">
                <Button type="submit" variant={ssoEnabled ? "outline-secondary" : "primary"} disabled={busy}>
                  {busy ? "Signing in…" : "Sign in"}
                </Button>
              </div>
            </Form>
          )}

          {!ssoEnabled && !localEnabled && (
            <Alert variant="warning" className="mb-0">
              No sign-in method is configured. Set TtsIdentity__Entra__* (and/or enable local login)
              on the server.
            </Alert>
          )}

          <p className="text-center text-muted mt-4 mb-0" style={{ fontSize: ".85rem" }}>
            New here? <a href="/guide">How to sign in and what you&apos;ll find</a>
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

function MicrosoftLogo() {
  return (
    <svg width="16" height="16" viewBox="0 0 21 21" aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}
